import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  setCookie,
  getEnvProfileDetailsUrl,
} from "../../../../helpers/helperfunctions";

const DefaultHeader = (props) => {
  const vaState = useSelector((state) => state.vaStateStore.vaState);
  const [envInfoUrl, setEvnInfoUrl] = useState(undefined);
  const [state, setState] = useState({
    hasLeftRefreshBtn: undefined,
    hasRightRefreshBtn: undefined,
    hasOpenNewWinodwBtn: undefined,
    hasCloseBtn: undefined,
    screen: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
  });
  const [popoutChat, setPopoutChat] = useState(undefined);

  const manageScreenResize = () => {
    const isPc = window.innerWidth >= 960 ? true : false;
    if (!state.hasLeftRefreshBtn && !state.hasRightRefreshBtn) {
      setState((prev) => {
        return { ...prev, hasLeftRefreshBtn: !isPc, hasRightRefreshBtn: isPc };
      });
    } else {
      if (state.hasRightRefreshBtn !== isPc) {
        setState((prev) => {
          return {
            ...prev,
            hasLeftRefreshBtn: !isPc,
            hasRightRefreshBtn: isPc,
          };
        });
      }
    }
  };
  useEffect(() => {
    manageScreenResize();
    if (window.location.hash) {
      const hash = window.location.hash?.substring(1);
      let newchatWindow,
        leftRefresh,
        rightRefresh,
        closeBtn = undefined;
      if (hash === "chatBot") {
        newchatWindow = true;
        leftRefresh = false;
        rightRefresh = true;
      }

      if (hash === "chatBot" || hash === "newWindow" || hash == "ofa") {
        closeBtn = true;
      }
      if (newchatWindow || leftRefresh || rightRefresh || closeBtn) {
        setState((prev) => {
          return {
            ...prev,
            hasOpenNewWinodwBtn: newchatWindow,
            hasLeftRefreshBtn: leftRefresh,
            hasRightRefreshBtn: rightRefresh,
            hasCloseBtn: closeBtn,
          };
        });
      }
    }
    window.addEventListener("resize", manageScreenResize);
    return () => window.removeEventListener("resize", manageScreenResize);
  }, []);
  useEffect(() => {
    if (vaState?.args?.profile) {
      setEvnInfoUrl(getEnvProfileDetailsUrl(vaState.args.profile));
    }
  }, [vaState?.args?.profile]);

  return (
    <nav className={`${vaState?.theme}-navbar`}>
      <div className={`${vaState?.theme}-navbar-flex-container`}>
        {state.hasLeftRefreshBtn && (
          <div className={`${vaState?.theme}-navbar-flex-item-1`}>
            <a
              className="navbar-icon left-padding-10"
              onClick={(e) => restartChat(props.store)}
            >
              <img
                src="https://nevocdndev.azureedge.net/images/VA/refresh_icon.png"
                alt="Refresh"
              />
            </a>
          </div>
        )}
        <div className={`${vaState?.theme}-navbar-flex-item-2`}>
          <img src="https://nevocdndev.azureedge.net/images/VA/virtual_agent_text_logo.svg" />
        </div>
        <div className={`${vaState?.theme}-navbar-flex-item-3`}>
          {envInfoUrl && (
            <a
              className="navbar-icon right-padding-20"
              onClick={(e) => showEnvProfileDetails(envInfoUrl)}
            >
              <img
                src="https://nevocdndev.azureedge.net/images/VA/question.svg"
                alt="Env Info"
              />
            </a>
          )}
          {state.hasRightRefreshBtn && (
            <a
              className="navbar-icon right-padding-20"
              onClick={(e) => restartChat(props.store)}
            >
              <img
                src="https://nevocdndev.azureedge.net/images/VA/refresh_icon.png"
                alt="Refresh"
              />
            </a>
          )}
          {state.hasOpenNewWinodwBtn && (
            <a
              className="navbar-icon right-padding-20"
              onClick={(e) =>
                openChatWindow(
                  props.store,
                  popoutChat,
                  setPopoutChat,
                  state.screen
                )
              }
            >
              <img
                src="https://nevocdndev.azureedge.net/images/VA/full_screen_icon.png"
                alt="Full Screen"
              />
            </a>
          )}
          {state.hasCloseBtn && (
            <a
              className="navbar-icon right-padding-20"
              onClick={(e) => closeChatWindow()}
            >
              <img
                src="https://nevocdndev.azureedge.net/images/VA/close_icon.png"
                alt="Exit"
              />
            </a>
          )}
        </div>
      </div>
    </nav>
  );
};

export default DefaultHeader;

const restartChat = (store) => {
  if (store) {
    store.dispatch({
      type: "WEB_CHAT/SEND_MESSAGE",
      payload: {
        text: "restart",
      },
    });
  }
};

const showEnvProfileDetails = (envInfoUrl) => {
  window.open(envInfoUrl);
};

const openChatWindow = (store, popoutChat, setPopoutChat, screen) => {
  // workaround to load the timout record VA-1856
  const activities = store.getState()?.activities;
  if (activities?.length > 0) {
    localStorage.setItem("activities", JSON.stringify(activities));
    localStorage.setItem("conversationId", activities[0].conversation.id);
  } else {
    localStorage.setItem("activities", undefined);
    localStorage.setItem("conversationId", "");
  }

  localStorage.setItem("isNewChatWindowOpen", "true");

  setCookie("isNewChatWindowOpen", true, {
    secure: true,
    "max-age": 3600,
    samesite: "none",
  });
  if (popoutChat !== undefined) {
    popoutChat.close();
  }

  var height = 550;
  var width = 400;

  var left = screen.width / 2 - width / 2;
  var top = screen.height / 2 - height / 2;
  const newChatWindow = window.open(
    window.location.href.split("#")[0],
    "_blank",
    "toolbar=yes,scrollbars=yes,resizable=yes,top=" +
      top +
      ",left=" +
      left +
      ",width=" +
      width +
      ",height=" +
      height
  );
  setPopoutChat(newChatWindow);

  closeChatWindow(); //sendMessage("close");
};

const closeChatWindow = () => {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash === "chatBot" || hash === "ofa") {
      window.parent.postMessage("close", "*");
      return;
    }
  }
  window.close();
};
